module.exports = __webpack_public_path__ + "img/succeed.4b0e8c48.png";